// @ts-nocheck
import React, { useState, useEffect, forwardRef, useImperativeHandle, useCallback } from "react";
import { Form, Row, Col, Container, Alert } from "react-bootstrap";
import PageLoading from "components/PageLoading";
import InputMask from "react-input-mask";
import SaveSubmitButtons from "../../../../../../components/SaveSubmitButtons/SaveSubmitButtons";
import {
  salvarRespostaComArquivos,
  getRespostaAtivaByLoggedUser,
} from "../../../../../../services/respostaService";
import {
  getSindicatoByLoggedUser,
  updateSindicato,
} from "../../../../../../services/sindicatoService";
import "./CadastroTab.css";

export interface CadastroTabRefHandle {
  handleSave?: () => Promise<{ show?: boolean; message?: string; type?: string }>;
}

export interface CadastroTabProps {
  isActive?: boolean;
  onProximo?: () => void;
  resposta?: unknown;
  sindicatoData?: unknown;
  setActiveTab?: (tab: string) => void;
}

const CadastroTab = forwardRef<CadastroTabRefHandle, CadastroTabProps>(
  ({ isActive, onProximo, resposta, sindicatoData }, ref) => {
    const [formData, setFormData] = useState({
      nome: "",
      cnpj: "",
      sigla: "",
      regional: "",
      ordenacao: "",
      grupo: "",
      presidente: "",
      email: "",
      telefone: "",
      coordenador: "",
      telCoordenador: "",
      responsavel: "",
      cargo: "",
    });
    const [receitaOperacional, setReceitaOperacional] = useState(0);
    useEffect(() => {
      if (formData.responsavel) {
        localStorage.setItem("responsavelQuestionaro", formData.responsavel);
      }
      if (formData.cargo) {
        localStorage.setItem("cargoResponsavel", formData.cargo);
      }
      if (formData.telefone) {
        localStorage.setItem("telefone", formData.telefone);
      }
      if (formData.coordenador) {
        localStorage.setItem("coordenador", formData.coordenador);
      }
      if (formData.telCoordenador) {
        localStorage.setItem("telCoordenador", formData.telCoordenador);
      }
    }, [
      formData.responsavel,
      formData.cargo,
      formData.telefone,
      formData.coordenador,
      formData.telCoordenador,
    ]);

    const [errors, setErrors] = useState({
      responsavel: false,
      cargo: false,
      telCoordenador: false,
      telefone: false,
      coordenador: false,
    });
    const [loading, setLoading] = useState(true);
    const [idResposta, setIdResposta] = useState(null);
    const [IdSindicato, setIdSindicato] = useState(null);
    const [, setFormDisabled] = useState(false);
    const [podeEditar, setPodeEditar] = useState(false);
    const [dataFim, setDataFim] = useState(false);
    const [showAdequacaoButton, setShowAdequacaoButton] = useState(false);
    useEffect(() => {
      if (!isActive) return;

      const fetchDados = async () => {
        setLoading(true);
        try {
          const sindicatoResp = await getSindicatoByLoggedUser();
          const sindicato = sindicatoResp.data;
          setIdSindicato(sindicato.id);
          localStorage.setItem("idSindicato", sindicato.id);

          let respostaData: { id?: number; json?: string; prazoEdicao?: boolean; dataFim?: string | null; docsObrigatorios?: Array<{ tema?: Array<{ criterio?: Array<{ campo?: Array<{ idCampo?: string; resposta?: unknown }> }> }> }> } | null = null;
          let jsonData: Record<string, unknown> = {};

          try {
            respostaData = (resposta as { data?: typeof respostaData })?.data ?? null;
            setIdResposta(respostaData?.id ?? null);

            const VerificarSePodeEditar = async () => {
              try {
                const res = resposta as { data?: { prazoEdicao?: boolean; dataFim?: string | null } };
                const podeEditar = res.data?.prazoEdicao ?? false;
                const datafim = res.data?.dataFim ?? null;
                const temAdequacao = false;

                setFormDisabled(!podeEditar);

                setShowAdequacaoButton(temAdequacao);

                setPodeEditar(podeEditar);
                setDataFim(datafim);
              } catch (error) {
                console.error("Erro ao verificar se pode editar:", error);
              }
            };

            await VerificarSePodeEditar();

            if (respostaData?.json) {
              jsonData = JSON.parse(respostaData.json);
            }
          } catch (error) {
            console.warn("⚠️ Falha ao buscar resposta ativa:", error);
          }

          const receitaVal = (() => {
            const docsObrigatorios =
              respostaData?.docsObrigatorios?.[0]?.tema ?? [];

            for (const tema of docsObrigatorios) {
              for (const criterio of tema.criterio || []) {
                for (const campo of criterio.campo || []) {
                  if (campo.idCampo === "DRE-receita-operacional") {
                    return campo.resposta;
                  }
                }
              }
            }

            return 0;
          })();

          setFormData({
            nome: sindicato.nome || "",
            cnpj: sindicato.cnpj || "",
            sigla: sindicato.sigla || "",
            regional: sindicato.regional || "",
            ordenacao: sindicato.ordenacao?.toString() || "",
            grupo: sindicato.grupo || "",
            presidente: sindicato.nomePresidente || "",
            email: sindicato.emailSindicato || "",
            telefone:
              String(jsonData?.telefoneSindicato ?? "") || sindicato.telefoneSindicato || "",
            coordenador:
              String(jsonData?.nomeCoordenador ?? "") || sindicato.nomeCoordenador || "",
            telCoordenador:
              String(jsonData?.telefoneCoordenador ?? "") || sindicato.telefoneCoordenador || "",
            responsavel:
              String(jsonData?.responsavelPreenchimento ?? "") ||
              sindicato.responsavelPreenchimento ||
              "",
            cargo: String(jsonData?.cargoResponsavel ?? "") || sindicato.cargoResponsavel || "",
          });

          setReceitaOperacional(receitaVal);
        } catch (error) {
          console.error("❌ Erro ao carregar sindicato:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchDados();
    }, [isActive]);

    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });

      setErrors((prevErrors) => ({
        ...prevErrors,
        [e.target.name]: false,
      }));
    };

    const isFormValid = () => {
      const newErrors = {
        responsavel: !formData.responsavel.trim(),
        cargo: !formData.cargo.trim(),
        telCoordenador: !formData.telCoordenador.trim(),
        telefone: !formData.telefone.trim(),
        coordenador: !formData.coordenador.trim(),
      };

      setErrors(newErrors);
      return Object.values(newErrors).every((err) => !err);
    };

    const handleSave = useCallback(async () => {
      if (!idResposta) {
        console.warn("⚠️ ID da resposta não encontrado.");
        return {
          show: true,
          message: "Não foi possível salvar os dados: resposta não carregada.",
          type: "error",
        };
      }

      try {
        setLoading(true);

        var data = {
          telefoneSindicato: formData.telefone,
          nomeCoordenador: formData.coordenador,
          telefoneCoordenador: formData.telCoordenador,
          idSindicato: IdSindicato,
        };

        try {
          await updateSindicato(data);
        } catch (error) {
          console.error("❌ Erro ao atualizar sindicato:", error);
          throw error;
        }

        const resposta = await getRespostaAtivaByLoggedUser();
        const respostaOriginal = resposta.data;

        const jsonOriginal = respostaOriginal?.json
          ? JSON.parse(respostaOriginal.json)
          : {};

        const jsonAtualizado = {
          ...jsonOriginal,
          receitaOperacional: receitaOperacional ?? 0 /*,
        telefoneSindicato: formData.telefone,
        telefoneCoordenador: formData.telCoordenador,
        nomeCoordenador: formData.coordenador,
        resposavelPreenchimento: formData.responsavel,
        cargoResposavel: formData.cargo,*/,
        };

        const payload = {
          json: JSON.stringify(jsonAtualizado),
          percentualConcluido: respostaOriginal.percentualConcluido ?? 0,
          idAcaoQuestionario: respostaOriginal.idAcaoQuestionario ?? 1,
          responsavelPreenchimento: formData.responsavel,
          cargoResponsavel: formData.cargo,
        };

        const receitaAtualizada = (() => {
          const temas = jsonAtualizado?.docsObrigatorios?.[0]?.tema || [];
          for (const tema of temas) {
            for (const criterio of tema.criterio || []) {
              for (const campo of criterio.campo || []) {
                if (campo.idCampo === "DRE-receita-operacional") {
                  const valor = parseFloat(
                    campo.resposta?.toString().replace(",", ".")
                  );
                  return isNaN(valor) ? 0 : valor;
                }
              }
            }
          }
          return 0;
        })();

        await salvarRespostaComArquivos(
          idResposta,
          payload,
          receitaAtualizada,
          []
        );

        return {
          show: true,
          message: "Informações salvas com sucesso!",
          type: "success",
        };
      } catch (error: unknown) {
        const err = error as { response?: { data?: unknown }; message?: string };
        console.error(
          "❌ Erro ao salvar:",
          err.response?.data ?? err.message
        );
        return {
          show: true,
          message: "Erro ao salvar os dados.",
          type: "error",
        };
      } finally {
        setLoading(false);
      }
    }, [idResposta, formData, IdSindicato, receitaOperacional]);

    const handleSubmit = async () => {
      const saveResult = await handleSave();
      if (saveResult?.type === "success") {
        onProximo?.(); // troca para a próxima aba
      }
    };

    useImperativeHandle(ref, () => ({ handleSave }), [handleSave]);

    return (
      <Container className="cadastro-container">
        <h1 className="cadastro-title">DADOS DO SINDICATO</h1>

        {loading ? (
          <PageLoading minHeight="50vh" />
        ) : (
          <>
            {!podeEditar && dataFim !== null && (
              <Alert variant="warning" className="mt-3">
                Você não pode mais editar os dados deste sindicato.
              </Alert>
            )}
            <Form>
              <Row className="gy-3">
                <Col xs={12}>
                  <Form.Group controlId="nome">
                    <Form.Label className="cadastro-label">
                      NOME DO SINDICATO
                    </Form.Label>
                    <Form.Control type="text" value={formData.nome} disabled />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="cnpj">
                    <Form.Label className="cadastro-label">
                      CNPJ DO SINDICATO
                    </Form.Label>
                    <Form.Control type="text" value={formData.cnpj} disabled />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="sigla">
                    <Form.Label className="cadastro-label">SIGLA</Form.Label>
                    <Form.Control type="text" value={formData.sigla} disabled />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="regional">
                    <Form.Label className="cadastro-label">REGIONAL</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.regional}
                      disabled
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="ordenacao">
                    <Form.Label className="cadastro-label">ORDENAÇÃO</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.ordenacao}
                      disabled
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="grupo">
                    <Form.Label className="cadastro-label">GRUPO</Form.Label>
                    <Form.Control type="text" value={formData.grupo} disabled />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="presidente">
                    <Form.Label className="cadastro-label">PRESIDENTE</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.presidente}
                      disabled
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="email">
                    <Form.Label className="cadastro-label">
                      E-MAIL DO SINDICATO
                    </Form.Label>
                    <Form.Control type="email" value={formData.email} disabled />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="telefone">
                    <Form.Label className="cadastro-label">
                      TELEFONE DO SINDICATO <span className="required">*</span>
                    </Form.Label>
                    <InputMask
                      mask="(99) 9999 9999"
                      className={`form-control ${errors.telefone ? "invalid-field" : ""
                        }`}
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleChange}
                    />
                    {errors.telefone && (
                      <p className="error-message">*Preencher o campo</p>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="coordenador">
                    <Form.Label className="cadastro-label">
                      NOME COORDENADOR(A) <span className="required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="coordenador"
                      value={formData.coordenador}
                      onChange={handleChange}
                      className={errors.coordenador ? "invalid-field" : ""}
                    />
                    {errors.coordenador && (
                      <p className="error-message">*Preencher o campo</p>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="telCoordenador">
                    <Form.Label className="cadastro-label">
                      TELEFONE COORDENADOR(A) <span className="required">*</span>
                    </Form.Label>
                    <InputMask
                      mask="(99) 99999 9999"
                      className={`form-control ${errors.telCoordenador ? "invalid-field" : ""
                        }`}
                      name="telCoordenador"
                      value={formData.telCoordenador}
                      onChange={handleChange}
                    />
                    {errors.telCoordenador && (
                      <p className="error-message">*Preencher o campo</p>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="responsavel">
                    <Form.Label className="cadastro-label">
                      RESPONSÁVEL PELO QUESTIONÁRIO{" "}
                      <span className="required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="responsavel"
                      value={formData.responsavel}
                      onChange={handleChange}
                      className={errors.responsavel ? "invalid-field" : ""}
                    />
                    {errors.responsavel && (
                      <p className="error-message">*Campo Obrigatório</p>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="cargo">
                    <Form.Label className="cadastro-label">
                      CARGO NO SINDICATO <span className="required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="cargo"
                      value={formData.cargo}
                      onChange={handleChange}
                      className={errors.cargo ? "invalid-field" : ""}
                    />
                    {errors.cargo && (
                      <p className="error-message">*Campo Obrigatório</p>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </Form>

            <div className="buttons-container">
              <SaveSubmitButtons
                onSave={handleSave}
                onSubmit={handleSubmit}
                podeEditar={podeEditar}
                temAdequacao={showAdequacaoButton}
              />
            </div>
          </>
        )}
      </Container>
    );
  });

CadastroTab.displayName = "CadastroTab";

export default CadastroTab;
